import type { PlanImageCardDTO } from '@mutations'
import { getRequest } from '../utils'

export const getPlanImageCards: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['getPlanImageCards', projectGuid],
  request: async (projectGuid: string): Promise<PlanImageCardDTO[]> => {
    const { data } = await getRequest<PlanImageCardDTO[]>({
      url: `/projects/${projectGuid}/plan-image-cards`,
    })

    return data || []
  },
}
